module.exports = __webpack_public_path__ + "b0c9b9b5126da172ae748ce73176a5bd.png";